"use client";
import React from "react";
import Footer from "../components/Footer";
import partnerIcon from '../assets/partner/icon.png';
import background from '../assets/random-graphic.png';
import FirstSection from "../components/common/FirstSection";
import WhyPartner from "../components/partner/WhyPartner";
import HowToGetStarted from "../components/common/HowToGetStarted";
import HeadingWithChips from "../components/common/HeadingWithChips";
const PartnerWithUs: React.FC = () => {
    const partnerSteps = [
        {
          number: "1",
          title: "Sign Up",
          description:
            "Register for the Affiliate Partner\n Program through our simple and\n convenient application process",
        },
        {
          number: "2",
          title: "Refer Clients",
          description:
            "introduce other businesses\nor individuals to EPAYR’s\n payment and banking solutions",
        },
        {
          number: "3",
          title: "Earn Rewards",
          description:
            "Receive personalized compensation\n based on your agreement, ensuring \nyour success is mutually beneficial",
        },
      ];
  return (
        <main>
        <FirstSection 
        icon={partnerIcon}
        iconAlt="Suite icon"
        backgroundImage={background}
        title="Are you an agent or a business with a strong network?"
        description={
            <>
            We offer a partnership that rewards your <br/>
            efforts while providing industry-leading <br/>
            payment solutions
            </>
        }
        buttonText="CONTACT US"
        buttonHref="/contact?type=company"
        buttonVariant="lightPurple"
        leftColumnSx={{
            backgroundColor: "beige.200"
        }}
        />
        <WhyPartner/>
        <HowToGetStarted steps={partnerSteps} title="HOW IT" highlightedTitle="WORKS"/>
        <HeadingWithChips 
          headingPrefix="READY TO "
          headingHighlight="START "
          headingSuffix="EARNING?"
          subheading=''
          discussionText={["", "WITH EPAYR AND TURN YOUR <br/> NETWORK NTO A SOURCE OF CONSISTENT"]}
              chips = {[
                { text: "PARTNER", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
                { text: "INCOME",  backgroundColor: "beige.200",  textColor: "beige.700" },
              ]}
              displayIcons={true}
        />
        <Footer 
              buttonText="CONTACT US" 
              buttonLink="/contact?type=company"
              ctaText={{
                prefix: 'CONTACT US TO',
                highlight1: ' EXPLORE <br/> ',
                middle: 'A PARTNERSHIP TAILORED TO YOU',
                highlight2: '',
                suffix: ''
              }}
            />
        </main>
  );
};

export default PartnerWithUs;
